import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { PRODUCT_CATEGORIES } from '~graphql/queries';
import { useApiGatewayQuery } from '~hooks';
import {
  GetProductCategoriesQuery,
  GetProductCategoriesQueryVariables,
  ProductCategory,
} from '~types/appsync.types';
import type { ProductCategoryOption } from '~types/productCategory';

const mapToOptions = (
  categories: Pick<ProductCategory, 'name' | 'shortname' | 'additionalInfo'>[],
): ProductCategoryOption[] =>
  categories.map((c) => ({
    additionalInfo: c.additionalInfo ?? undefined,
    label: c.name,
    numSkiLift: c.additionalInfo?.numSkiLift ?? undefined,
    numTotalSlopes: c.additionalInfo?.numTotalSlopes ?? undefined,
    shortDescription: c.additionalInfo?.shortDescription ?? undefined,
    shortname: c.shortname,
  }));

const useProductCategories = (
  contractorId?: number,
  options?: {
    skip?: boolean;
  },
): [ProductCategoryOption[], boolean, ApolloError | undefined] => {
  const { data, loading, error } = useApiGatewayQuery<
    GetProductCategoriesQuery,
    GetProductCategoriesQueryVariables
  >(PRODUCT_CATEGORIES, {
    skip: options?.skip,
    variables: {
      contractorId,
    },
  });

  const productCategories = useMemo(
    () => (data?.productCategories ? mapToOptions(data.productCategories) : []),
    [data],
  );

  return [productCategories, loading, error];
};

export default useProductCategories;
